// Offline sale queue — persists pending sales in localStorage.
// When the network is down, doSale() enqueues here instead of calling the API.
// useOfflineSync drains this queue when the connection is restored.

const KEY = 'mmm_offline_queue_v1';

export const getQueue = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
  catch { return []; }
};

export const enqueue = (sale) => {
  const q = getQueue();
  const item = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    queuedAt: Date.now(),
    ...sale,
  };
  localStorage.setItem(KEY, JSON.stringify([...q, item]));
  // Notify any listeners (e.g. useOfflineSync in Layout) that the count changed
  window.dispatchEvent(new CustomEvent('mmm_queue_updated'));
  return item;
};

export const dequeue = (id) => {
  const q = getQueue().filter(x => x.id !== id);
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new CustomEvent('mmm_queue_updated'));
};

export const markFailed = (id, reason) => {
  const q = getQueue().map(x => x.id === id ? { ...x, failed: true, failReason: reason } : x);
  localStorage.setItem(KEY, JSON.stringify(q));
};

export const clearQueue = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent('mmm_queue_updated'));
};
